<template>
  <div class="home-header">
    <div class="left f-r-vc">
      <svg-icon
        icon-class="collapse"
        class="collapse-but"
        @click.native="toggleSideNav"
      />
      <svg-icon icon-class="back" class="back-but" @click.native="goBack" />
      <svg-icon
        icon-class="forward"
        class="forward-but"
        @click.native="goForward"
      />
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          v-for="([nav, path], index) in navNames.slice(0, navNames.length - 1)"
          :key="'nav-item-' + index"
          :to="{ path }"
        >
          {{ nav }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          {{ navNames[navNames.length - 1][0] }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="right">
      <email-config />
      <el-dropdown @command="handUserMenuClick">
        <el-button type="primary" size="small" plain class="avatar">
          <div class="f-r-vc">
            <svg-icon icon-class="avatar" />
            {{ nickname }}<i class="el-icon-arrow-down el-icon--right"></i>
          </div>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="userInfo">Account Info</el-dropdown-item>
          <el-dropdown-item command="logOut">Sign Out</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SideNavMessage from '@/core/message/sidenav'
// components
import EmailConfig from '@/components/user/EmailConfig.vue'
export default {
  components: { EmailConfig },
  name: 'HomeHeader',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['username', 'nickname']),
    navNames() {
      const matched = this.$route.matched
      const temp = matched.slice(1).map(item => [item.meta.name, item.path])
      return temp
    }
  },
  methods: {
    toggleSideNav() {
      SideNavMessage.emit(SideNavMessage.eventMap.OPEN_CLOSE_SIDE_MENU)
    },
    goBack() {
      this.$router.back()
    },
    goForward() {
      this.$router.forward()
    },
    handUserMenuClick(command) {
      if (command === 'userInfo') {
        if (this.$route.path !== '/user') {
          this.$router.push({ path: '/user' })
        }
      } else {
        // logout
        this.$store.dispatch('logOut')
        this.$router.push({ path: '/login' })
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.home-header {
  user-select: none;
  height: $home-header-height;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .svg-icon {
    width: 28px !important;
    height: 28px !important;
  }

  .left {
    .collapse-but {
      margin-left: 15px;
    }

    .back-but {
      margin-left: 10px;
      padding: 5px;
      width: 56px;
      height: 56px;
    }

    .forward-but {
      margin-left: 5px;
    }

    .el-breadcrumb {
      margin-left: 20px;
    }

    .collapse-but,
    .back-but,
    .forward-but {
      width: 20px;
      height: 20px;
      padding: 5px;
      border-radius: $radius-buttom-common;

      &:hover {
        background-color: #c7c6c6;
        cursor: pointer;

        @extend .shadow-level-three;
      }
    }
  }

  .right {
    // width: 80px;
    padding-right: 20px;

    @extend .f-r-c-sb;

    .avatar {
      border: none;
      padding: 0;
      background-color: $global-background-color;
      color: black;
      font-size: 16px;
      // padding: 8px 10px;
      &:hover {
        color: black;
        cursor: pointer;
      }

      .svg-icon {
        width: 28px;
        height: 28px;
        margin-right: 10px;
      }
    }
  }
}
</style>
